import Layout from '../../Components/Layout/Layout';
import styles from './TrackOrder.module.scss';
import { useNavigate, useParams } from 'react-router-dom';
import { useState, useEffect } from 'react';
import axios from '../../config/axios';
import { Spin, Tag, Divider, Button, Row, Col, message } from 'antd';
import { TagColorByOrder } from '../../utils/helpers';
import moment from '../../config/moment';

const TrackOrder = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [order, setOrder] = useState({});

    useEffect(() => {
        (async () => {
            try {
                const res = await axios.get(`/orders/${id}`);
                setOrder(res.data);
            } catch (error) {
                message.error("Invalid order ID")
                navigate("/track-order")
            } finally {
                setLoading(false);
            }

        })();
    }, [id, navigate]);

    return (
        <Layout title={`Track Order - ${id}`}>
            <div className='container'>
                {loading ? (
                    <div className={styles.order_loading}>
                        <Spin />
                    </div>
                ) : (
                    <div className={styles.order_card}>
                        <div>
                            <div className={styles.id_and_status}>
                                <span className={styles.order_id}> Order ID: {id} </span>
                                <Tag color={TagColorByOrder(order.status)}>{order.status.toUpperCase()}</Tag>
                            </div>
                            <span> {moment(order.timestamp).format('MMMM D, YYYY - LT')} </span>
                            <div className={styles.order_total_text}>Order Total: €{order.total}</div>
                        </div>
                        <Divider style={{ margin: '5px 0 10px 0' }} />
                        <div>
                            <div className={styles.order_items_title}>Order Items</div>
                            <OrderedItems order={order} />
                        </div>
                        <Divider style={{ margin: '5px 0 10px 0' }} />

                        <div>
                            <div className={styles.order_items_title}>Invoices</div>
                            <Invoices order={order} />
                        </div>
                        <Divider style={{ margin: '5px 0 10px 0' }} />

                        <div>
                            <div className={styles.order_items_title} style={{ marginBottom: 10 }}>Order Information</div>
                            <OrderInformation order={order} />
                        </div>
                    </div>
                )}
            </div>
        </Layout>
    );
};

export default TrackOrder;

const OrderedItems = ({ order }) => {
    return (
        <div className={styles.order_items_table}>
            <table>
                <thead>
                    <tr>
                        <th>Item Image</th>
                        <th>Item Name</th>
                        <th>Price</th>
                        <th>Quantity</th>
                    </tr>
                </thead>

                <tbody>
                    {order.order_items.map((item, index) => {
                        return (
                            <tr key={index}>
                                <td>
                                    <img src={item.image} width='50px' alt={index} />
                                </td>
                                <td>{item.title}</td>
                                <td> {item.order_time_price}</td>
                                <td>
                                    <span>{item.quantity} Unit</span>
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};

const Invoices = ({ order }) => {
    return (
        <div className={styles.invoice_table}>
            <div style={{ fontWeight: 500, marginTop: 10 }}>Invoices Under This Order is/are Below</div>
            <table>
                <tbody>
                    <tr>
                        <td>{`${order.id}`}</td>

                        <td>
                            <a target='_blank' href={`/order/invoice?invoiceID=${order.id}`} className={'primary-link'} rel='noreferrer'>
                                <Button type='text' size='small'>
                                    View
                                </Button>
                            </a>
                            |
                            <a target='_blank' href={`/order/invoice?invoiceID=${order.id}&print=true`} className={'primary-link'} rel='noreferrer'>
                                <Button type='text' size='small'>
                                    Print
                                </Button>
                            </a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};

const OrderInformation = ({ order }) => {
    return (
        <Row gutter={[16, 16]}>
            <Col lg={6} xs={24}>
                <div style={{ fontWeight: 600, fontSize: 16 }}>Shipping Address</div>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <span>House No: {order.house_no}</span>
                    <span>Street Address: {order.street_address}</span>
                    <span>State: {order.state}</span>
                    <span>City: {order.city}</span>
                    <span>Country: {order.country?.toUpperCase()}</span>
                </div>
            </Col>

            <Col lg={6} xs={24}>
                <div style={{ fontWeight: 600, fontSize: 16 }}>Delivery Method</div>
                <Tag
                    style={{
                        width: "fit-content",
                        textTransform: "uppercase",
                    }}
                    color="#87d068"
                >
                    {order.delivery_method}
                </Tag>
            </Col>

            <Col lg={6} xs={24}>
                <div style={{ fontWeight: 600, fontSize: 16 }}>Billing Address</div>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <span>House No: {order.house_no}</span>
                    <span>Street Address: {order.street_address}</span>
                    <span>State: {order.state}</span>
                    <span>City: {order.city}</span>
                    <span>Country: {order.country?.toUpperCase()}</span>
                </div>
            </Col>

            <Col lg={6} xs={24}>
                <div style={{ fontWeight: 600, fontSize: 16 }}>Payment Method</div>
                <Tag
                    style={{
                        width: "fit-content",
                        textTransform: "uppercase",
                    }}
                    color="#87d068"
                >
                    {order.payment_method}
                </Tag>
            </Col>
        </Row>
    );
};
